import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import CustomNavbar from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";

import TreatmentHero from "../components/Treatment/TreatmentHero";
import TreatmentSidebar from "../components/Treatment/TreatmentSidebar";
import TreatmentContent from "../components/Treatment/TreatmentContent";
import TreatmentFAQ from "../components/Treatment/TratmentFAQ";

function TreatmentPage(props) {
  const { title, faqs } = props;

  return (
    <>
      <CustomNavbar />
      <TreatmentHero title={title} />

      <section className="py-5">
        <Container>
          <Row>

            {/* ✅ SIDEBAR (LEFT on desktop, BOTTOM on mobile) */}
            <Col
              md={4}
              className="order-2 order-md-1 mt-4 mt-md-0"
            >
              <div style={{ position: "sticky", top: "100px" }}>
                <TreatmentSidebar />
              </div>
            </Col>

            {/* ✅ MAIN CONTENT */}
            <Col
              md={8}
              className="order-1 order-md-2"
            >
              <TreatmentContent {...props} />
              <TreatmentFAQ faqs={faqs} />
            </Col>

          </Row>
        </Container>
      </section>

      <Footer />
    </>
  );
}

export default TreatmentPage;